import { useTranslation } from 'react-i18next';
import { KccButton } from 'lib/components/KccButton/KccButton';

interface ManualEntryFooterProps {
  onScanBarcode: () => void;
}

export const ManualEntryFooter = ({ onScanBarcode }: ManualEntryFooterProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <span className="manual-entry__or">{t('common.or')}</span>
      <KccButton className="manual-entry__scan-btn" type="secondary" block onClick={onScanBarcode}>
        {t('service.identifyDevice.manualEntry.scanButton')}
      </KccButton>
    </>
  );
};
